import { gql } from '@apollo/client';

export const UPDATE_EXAM = gql`
  mutation UpdateExam(
    $updateExamId: MongoID!
    $updateExamRecord: UpdateByIdExamInput!
  ) {
    updateExam(_id: $updateExamId, record: $updateExamRecord) {
      record {
        _id
        technology
        device
        examDate
        clinicalIndication
        histologicalResult
        laboratoryResult {
          glucoseLevel
          ceaLevel
        }
        status
        filters
        priority
        user {
          _id
          institution {
            _id
          }
        }
        physician {
          _id
        }
        media {
          fullVideo
          highlights
          frames
        }
        models
        medicalNotes {
          _id
          content
          user {
            _id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const GET_EXAM_STATUS = gql`
  query GetExamStatus($examId: MongoID!) {
    exam(filter: { _id: $examId }) {
      status
    }
  }
`;

export const GET_USERS = gql`
  query GetUsers($sort: SortFindManyUserInput) {
    users(sort: $sort) {
      _id
      firstName
      lastName
      avatar
    }
  }
`;
